import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { ToastProvider } from './components/Toast.jsx'
import { initSentry, captureException } from './sentry.js'

// Initialize Sentry error monitoring (no-op if VITE_SENTRY_DSN is not set)
initSentry()

// Global handler for Supabase Auth LockManager timeouts.
// Supabase uses Navigator.locks for token refresh coordination.
// On tab switch, a lock timeout may fire — suppress it silently
// instead of reloading (which disrupts the user experience).
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message || event.reason || '')
  if (msg.includes('Navigator LockManager') || (msg.includes('lock') && msg.includes('timed out'))) {
    console.warn('Baulit: Auth lock timeout suppressed (tab switch)')
    event.preventDefault()
    return
  }
  // Forward unhandled promise rejections to Sentry
  if (event.reason instanceof Error) {
    captureException(event.reason, { source: 'unhandledrejection' })
  }
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>
  </StrictMode>,
)
